import React, { useState, useMemo, useCallback } from 'react';
import { Box, Icon, Typography, IconButton } from '@material-ui/core';

import Loading from './Loading';
import useStyles from './styles';

const MsgCollapse = ({ type, title, message, loading }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(true);

  const icon = useMemo(() => {
    switch (type) {
      case 'alert':
        return 'warning_amber';
      case 'error':
        return 'error_outline';
      case 'success':
        return 'check_circle';
      default:
        return 'info';
    }
  }, [type]);

  const toggleExpand = useCallback(() => {
    setExpanded(oldExpanded => !oldExpanded);
  }, []);

  return loading ? (
    <Loading />
  ) : (
    <Box
      className={`${classes.container} ${type} ${expanded && 'is-expanded'}`}
    >
      <Icon
        className="msg-collapse-icon"
        fontSize={expanded ? 'large' : 'default'}
      >
        {icon}
      </Icon>
      <Box className="msg-collapse-text-container">
        <Typography
          className="msg-collapse-text-title"
          variant={expanded ? 'subtitle1' : 'body2'}
        >
          {title}
        </Typography>
        {expanded && (
          <Typography className="msg-collapse-text-message" variant="caption">
            {message}
          </Typography>
        )}
      </Box>
      <IconButton className="msg-collapse-btn-expand" onClick={toggleExpand}>
        <Icon>{`expand_${expanded ? 'less' : 'more'}`}</Icon>
      </IconButton>
    </Box>
  );
};

export default MsgCollapse;
